<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import infoIcon from "../../../../../static/assets/images/info-icon.svg";
export default {
  props: ["video", "index"],
  data() {
    return {
      infoIcon,
      shortDescriptionLimitCount: 120,
      longDescriptionLimitCount: 300,
    };
  },
  computed: {
    short_description: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "short_description",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.short_description;
        }
        return "";
      },
    },
    long_description: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "long_description",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.long_description;
        }
        return "";
      },
    },
    library: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "library",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.library;
        }
        return "";
      },
    },
    recommendation: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "recommendation",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.recommendation;
        }
        return "";
      },
    },

    status: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "status",
          value: "in_editing",
        });
      },
      get() {
        if (this.video) {
          return this.video.status;
        }
        return "in_editing";
      },
    },
    program: {
      set(value) {
        this.$store.commit(`workouts/setVideoField`, {
          index: this.index,
          fieldName: "program",
          value,
        });
      },
      get() {
        if (this.video) {
          return this.video.program;
        }
        return "";
      },
    },
  },

  methods: {
    tabStatus(status) {
      this.$store.commit(`workouts/setTabStatus`, status);
    },
  },
  watch: {
    short_description() {
      this.tabStatus(true);
    },
    long_description() {
      this.tabStatus(true);
    },
    library() {
      this.tabStatus(true);
    },
    recommendation() {
      this.tabStatus(true);
    },
    status() {
      this.tabStatus(true);
    },
    program() {
      this.tabStatus(true);
    },
  },
};
</script>
<template>
  <div class="mb-5" v-if="!video.hidden">
    <div class="card bg-light px-4 py-4 border">
      <div class="card-body">
        <span class="bg-dark text-white badge inline-block mr-1">{{
          video.render_type
        }}</span>
        <span class="inline-block">ID {{ video.id }}</span>
        <h2 class="my-3 mb-4 text-uppercase">{{ video.xali_title }}</h2>
        <b-form-group>
          <label for="short" class="d-inline-block"
            >SHORT DESCRIPTION (120 CHAR MAX)</label
          >

          <div class="tooltip-wrapper d-inline-block">
            <img :src="infoIcon" />
            <div class="data">
              Please input a short description, this may be used in the app in
              locations where only a preview of the description is visible.
            </div>
          </div>
          <b-form-textarea
            :maxlength="shortDescriptionLimitCount"
            v-model="short_description"
            id="short"
            placeholder="Enter Short Description"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group>
          <label for="long" class="d-inline-block">
            LONG DESCRIPTION (300 CHAR MAX)
          </label>
          <div class="tooltip-wrapper d-inline-block">
            <img :src="infoIcon" />
            <div class="data">
              This description will be visible on the member app in each item,
              use the preview tool to see how it will look.
            </div>
          </div>
          <b-form-textarea
            :maxlength="longDescriptionLimitCount"
            v-model="long_description"
            id="long"
            placeholder="Enter Long Description"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            name="check-button"
            switch
            class="custom-switch"
            v-model="library"
          >
            Library
          </b-form-checkbox>
          <b-form-checkbox
            name="check-button"
            switch
            class="custom-switch"
            v-model="recommendation"
          >
            Recommendation Engine
          </b-form-checkbox>
          <b-form-checkbox
            name="check-button"
            switch
            class="custom-switch"
            v-model="program"
          >
            Program
          </b-form-checkbox>
        </b-form-group>
      </div>
    </div>
  </div>
</template>